import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBReport {
  // 当月销售额统计图
  static getMonthSalesStatistics() {
    const url = `/api/db/sale/volume/thirty/days`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 销售区域分布图
  static getSalesArea(options) {
    let url = `/api/db/sale/volume/city?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 年销售额统计总览图
  static getYearSalesStatistics() {
    const url = `/api/db/sale/volume/year`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 各类商品销售趋势图
  static getMonthGoodsSales(month) {
    const url = `/api/db/goods/volume/category/trend?month=${month}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 商品前十销售排行榜
  static getTenTopGoodsSales(options) {
    let url = '/api/db/goods/volume/top/ten?'
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 各类商品销售占比图
  static getGoodsProportion(options) {
    let url = '/api/db/goods/volume/category/ratio?'
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 商品销售排行榜
  static getGoodsSalesRankingList(options) {
    let url = '/api/db/goods/volume/page/leader/board?'
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 30天活跃用户趋势图
  static getMonthActiveUsre() {
    const url = `/api/db/customer/volume/thirty/days/login/count`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 30天新用户趋势图
  static getMonthNewUsre() {
    const url = `/api/db/customer/volume/thirty/days/register/count`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 当月客户贡献排名
  static getMonthCustomersRanking() {
    const url = `/api/db/customer/volume/list/customer/contribute/rank`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 客户贡献排名详情
  static getCustomersRankingDetails(options) {
    let url = `/api/db/customer/volume/page/customer/contribute/rank?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBReport;